export const LTSReleases = [
  { value: "resolute", label: "26.04" },
  { value: "noble", label: "24.04" },
  { value: "jammy", label: "22.04" },
  { value: "focal", label: "20.04" },
  { value: "bionic", label: "18.04" },
  { value: "xenial", label: "16.04" },
  { value: "trusty", label: "14.04" },
];
